import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';


@Pipe({
  name: 'toDateTime'
})
export class ToDateTimePipe implements PipeTransform {


    transform(value: string): string {
        try {
if (value != null && value.trim() != "") {
    let ret = "";
      ret = moment(value).format('DD MMMM YYYY h:mm a');

      return ret;
    }
   
        } catch (e) {
 return "";
        }
    


  }

}
